import { defaultUnderlineStyle } from "@ecco/ui/css/common";

export const allResultsLinkStyles = {
    _hover: {
        "--b": "100%",
        ...defaultUnderlineStyle,
    },
    _active: {
        ...defaultUnderlineStyle,
    },
    fontSize: "desktopBodyTextNormal",
};

export const querySuggestionItemLinkStyles = {
    color: "black",
    fontWeight: "semibold",
    textDecor: "none",
    textTransform: "capitalize",
    display: "flex",
    _hover: {
        "--b": "100%",
        color: "black",
        ...defaultUnderlineStyle,
    },
    _active: {
        color: "black",
        ...defaultUnderlineStyle,
    },
} as const;

export const querySuggestionMarkHighlightStyles = {
    "& mark": {
        background: "transparent",
        color: "gray.500",
    },
};

export const querySuggestionItemLinkHighlightStyles = {
    "& span": {
        color: "black",
    },
};

export const querySuggestionsListStyles = {
    display: "flex",
    flexDirection: "column",
    gap: 3,
} as const;

export const GRID_AREAS = {
    suggestions: "suggestions",
    products: "products",
};
